module.exports = __webpack_public_path__ + "img/icon_1.72b930be.png";